import { FC, useEffect, useRef } from 'react'
import mixpanel from 'mixpanel-browser'

import { Feed, FeedType } from '../../../types/Feed'
import Exercise from '../../Exercise'
import Result from '../../Result'
import TherapistPost from '../TherapistPost'
import MediaPost from '../MediaPost'
import FeedbackPost from '../FeedbackPost'
import { useOnScreen } from '../../../common/hooks/useOnScreen'

interface ItemProps {
  post: Feed
}

const FeedItem: FC<ItemProps> = ({ post }) => {
  const ref = useRef<HTMLDivElement>(null)
  const isOnScreen = useOnScreen(ref)

  useEffect(() => {
    if (isOnScreen) {
      mixpanel.track('Post View', {
        id: post.id,
        type: post.type,
      })
    }
  }, [isOnScreen, post])

  let feedItem = null

  switch (post.type) {
    case FeedType.CONTENT:
      feedItem = (
        <MediaPost post={post.content} contentType={post.content.type} />
      )
      break
    case FeedType.EXERCISE:
      feedItem = <Exercise exercise={post.content} />
      break
    case FeedType.RESULT:
      feedItem = <Result result={post} />
      break
    case FeedType.THERAPIST:
      feedItem = <TherapistPost therapist={post.content} />
      break
    case FeedType.FEEDBACK:
      feedItem = <FeedbackPost />
      break
  }

  return <div ref={ref}>{feedItem}</div>
}

export default FeedItem
